import React from "react";
import ProfileRight from "../Components/ProfileRight";
import "./header.css";
import SidebarLayout from "../Components/sidebar/SidebarLayout";

function Profile() {
  return (
    <>
      <SidebarLayout>
        <div style={{ position: "relative" }}>
          <ProfileRight />
        </div>
      </SidebarLayout>
    </>
  );
}

export default Profile;
